
<template>

  <svg viewBox="0 0 150 100" aria-hidden="true">

    <path d="m103.34 32.204c9.861 0 17.807 7.9975 17.807 17.807 0 9.8352-7.9458 17.833-17.807 17.833h-4.6588v-35.64zm1.8117 51.22c18.454 0 33.465-14.986 33.465-33.414 0-18.506-14.856-33.465-33.31-33.465h-20.68v66.905h20.524"
    
      fill="currentColor" />

    <path d="m59.418 16.534-48.037 66.932h21.508l5.6426-8.8516h24.537v8.8516h14.648v-66.932zm3.7402 20.168v23.967h-15.426z"
    
      fill="currentColor" />

  </svg>

</template>